import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import MediaSmDown from 'components/Responsive/MediaSmDown';

export default function ResponsiveMenuComponent(props) {
  const {
    bgImage,
    mapIsEnabled,
    mapTitle,
    onOpenMap,
    onOpenSidebar,
  } = props;
  return (
    <ReactCSSTransitionReplace
      childComponent="div"
      transitionName="fade"
      transitionEnterTimeout={1000}
      transitionLeaveTimeout={1000}
    >
      <nav
        key={bgImage}
        className="banner banner--md-down"
        aria-hidden="true"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <ul className="banner__list--md-down">
          <li className="banner-item">
            <button title="Menu" className="button--link banner__button" onClick={onOpenSidebar} type="button">
              <i className="fa fa-bars fa-3x" />
              <span className="u-visually-hidden">Menu</span>
            </button>
          </li>
          <MediaSmDown>
            <li className="banner-item">
              <button className="button--link banner__button" title={mapTitle} onClick={onOpenMap} type="button">
                <i
                  className={classnames(
                    'fa fa-compass fa-3x',
                    'icon--has-transition',
                    !mapIsEnabled && 'icon--disabled',
                  )}
                />
                <span className="u-visually-hidden">Map</span>
              </button>
            </li>
          </MediaSmDown>
        </ul>
      </nav>
    </ReactCSSTransitionReplace>
  );
}

ResponsiveMenuComponent.propTypes = {
  bgImage: PropTypes.string.isRequired,
  mapIsEnabled: PropTypes.bool.isRequired,
  mapTitle: PropTypes.string.isRequired,
  onOpenMap: PropTypes.func.isRequired,
  onOpenSidebar: PropTypes.func.isRequired,
};